import {
  GET_LOTTERY_QUERY_RESULT_REQUEST,
  GET_LOTTERY_QUERY_RESULT_SUCCESS,
  GET_LOTTERY_QUERY_RESULT_FAILURE,
  GET_LOTTERY_QUERY_RESULT_RESET
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LOTTERY_QUERY_RESULT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_LOTTERY_QUERY_RESULT_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case GET_LOTTERY_QUERY_RESULT_RESET:
      return initialState;
    case GET_LOTTERY_QUERY_RESULT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
